import { Component, EventEmitter, Input, OnInit, AfterViewInit, OnDestroy, HostListener, Output, ViewChild, ElementRef } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import html2canvas from 'html2canvas';
import jspdf from 'jspdf';
import { FarmerService } from 'src/app/services/farmer.service';
import { LotteryDrillDownContext } from '../lottery-dashboard/lottery-dashboard.component';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-lottery-booking-details',
  templateUrl: './lottery-booking-details.component.html',
  styleUrls: ['./lottery-booking-details.component.scss']
})
export class LotteryBookingDetailsComponent implements OnInit, AfterViewInit, OnDestroy {

  @Input() drillData: LotteryDrillDownContext;
  @Input() divisionName: string;
  @Input() subDivisionName: string;
  @Input() villageName: string;
  @Input() bookingId: number;

  @Output() closed = new EventEmitter<boolean>();
  @Output() closedToVillage = new EventEmitter<boolean>();
  @Output() closedToSubDivision = new EventEmitter<boolean>();
  @Output() closedToDivision = new EventEmitter<boolean>();
  @Output() toDashboardComp = new EventEmitter<boolean>();

  loading = true;
  session: any;

  jointOwnersColumns = ['ownerNameRor', 'ownerIdentifierName', 'ownerIdentifierRelationship'];
  jointOwnersDataSource = new MatTableDataSource<any>([]);

  showScrollUp: boolean = false;
  showScrollDown: boolean = false;
  scrollPercent: number = 0;
  @ViewChild("scrollNavBtns") scrollNavBtns: ElementRef;

  constructor(private farmerService: FarmerService) { }

  ngOnInit(): void {
    this.loading = true;
    this.farmerService.getfarmerbookinggridbyidlist(this.bookingId, true).subscribe((result: any) => {
      this.session = result;
      this.jointOwnersDataSource.data = this.session?.jointOwners || [];
      this.loading = false;
      setTimeout(() => this.checkScrollPosition());
    }, () => {
      this.session = null;
      this.loading = false;
    });
  }

  ngAfterViewInit(): void {
    if (this.scrollNavBtns) {
      document.body.appendChild(this.scrollNavBtns.nativeElement);
    }
    this.checkScrollPosition();
  }

  ngOnDestroy(): void {
    if (this.scrollNavBtns) {
      this.scrollNavBtns.nativeElement.remove();
    }
  }

  @HostListener("window:scroll", [])
  @HostListener("window:resize", [])
  checkScrollPosition(): void {
    const scrollTop = window.pageYOffset;
    const pageHeight = document.body.scrollHeight;
    const windowHeight = window.innerHeight;
    const maxScroll = pageHeight - windowHeight;

    this.showScrollUp = scrollTop > 0;
    this.showScrollDown = scrollTop < maxScroll;
    this.scrollPercent = maxScroll > 0 ? (scrollTop / maxScroll) * 100 : 0;
  }

  scrollToTop(): void {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }

  scrollToBottom(): void {
    window.scrollTo({ top: document.body.scrollHeight, behavior: "smooth" });
  }

  get isSelected(): boolean {
    return !!this.session && this.session.bookingStatus !== 'Cancelled';
  }

  get isUtilized(): boolean {
    return !!this.session && this.session.bookingStatus === 'Completed';
  }

  getStatusClass(status: string): string {
    switch (status) {
      case 'Completed':
        return 'seekClr';
      case 'Booked':
        return 'mer2';
      case 'Cancelled':
        return 'reject';
      default:
        return 'green1';
    }
  }

  download1(): void {
    const element = document.querySelector<HTMLElement>('#element');
    if (!element) {
      return;
    }

    html2canvas(element).then(canvas => {
      const pdf = new jspdf();
      pdf.addImage(canvas.toDataURL('image/png'), 'PNG', 0, 0, 211, 298);
      pdf.save('Booking Details.pdf');
    });
  }

  downloadDeliveryInvoice(): void { if (!this.session?.deliveryInvoiceCopyImagePath) { return; } 
  const src = environment.imageBaseUrl + 'DBT/DeliveryInvoiceCopy/' + this.session.deliveryInvoiceCopyImagePath; 
  window.open(encodeURI(src)); 
  const downloadLink = document.createElement('a'); 
  const fileName = this.session.deliveryInvoiceCopyImagePath; 
  downloadLink.href = src; 
  downloadLink.download = fileName; }

  downloadRcBook(): void {
  if (!this.session?.rcBookImagePath) {
    return;
  }

  const src =
    environment.imageBaseUrl +
    'DBT/DBTRcBook/' +
    this.session.rcBookImagePath;

  window.open(encodeURI(src));

  const downloadLink = document.createElement('a');
  const fileName = this.session.rcBookImagePath;

  downloadLink.href = src;
  downloadLink.download = fileName;
}

 downloadReferenceCopy(): void {
  if (!this.session?.referenceCopyImagePath) {
    return;
  }

  const src =
    environment.imageBaseUrl +
    'DBT/PaymentReferenceCopy/' +
    this.session.referenceCopyImagePath;

  window.open(encodeURI(src));

  const downloadLink = document.createElement('a');
  const fileName = this.session.referenceCopyImagePath;

  downloadLink.href = src;
  downloadLink.download = fileName;
}

  onCancel(): void {
    this.closed.emit(true);
  }

  goToVillage(): void {
    this.closedToVillage.emit(true);
  }

  goToSubDivision(): void {
    this.closedToSubDivision.emit(true);
  }

  goToDivision(): void {
    this.closedToDivision.emit(true);
  }

  goToDashboard(): void {
    this.toDashboardComp.emit(true);
  }

  PattaDowndload(session: any): void {
    const src = environment.imageBaseUrl + 'DBT/Patta/' + session.pattaImagePath;
    window.open(encodeURI(src), '_blank');
  }

  ChittaDownload(session: any): void {
    const src = environment.imageBaseUrl + 'DBT/Chitta/' + session.chittaImagePath;
    window.open(encodeURI(src), '_blank');
  }

  adangalDownload(session: any): void {
    const src = environment.imageBaseUrl + 'DBT/Adangal/' + session.adangalImagePath;
    window.open(encodeURI(src), '_blank');
  }

  FmbDownload(session: any): void {
    const src = environment.imageBaseUrl + 'DBT/FMB/' + session.fmbImagePath;
    window.open(encodeURI(src), '_blank');
  }

  FarmertypeDownload(session: any): void {
    const src = environment.imageBaseUrl + 'DBT/FarmerType/' + session.farmerTypeImagePath;
    window.open(encodeURI(src), '_blank');
  }

  toHectare(acreValue: string): number {
    const acres = parseFloat(acreValue);
    return isNaN(acres) ? null : acres * 0.404685642;
  }
}
